var _path, _path2, _path3, _path4, _rect, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAutomaticInvoiceGeneration(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 350,
    height: 350,
    viewBox: "0 0 350 350",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M117.5 95.5C117.5 78.3792 131.155 64.5 147.998 64.5H246.5C229.656 64.5 216.002 78.3792 216.002 95.5H117.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M246.5 56H147.998C126.33 56 109 73.816 109 95.5V104H224.502V95.5C224.502 82.9423 234.481 73 246.5 73V56ZM214.447 73C211.595 77.1624 209.515 81.9017 208.409 87H127.619C130.915 78.7373 138.868 73 147.998 73H214.447Z",
    fill: "#102F5D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5 90.5C46.5 88.2909 48.2909 86.5 50.5 86.5H266.5C268.709 86.5 270.5 88.2909 270.5 90.5V217.5C270.5 219.709 268.709 221.5 266.5 221.5H50.5C48.2909 221.5 46.5 219.709 46.5 217.5V90.5Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39 90.5C39 84.1487 44.1487 79 50.5 79H266.5C272.851 79 278 84.1487 278 90.5V217.5C278 223.851 272.851 229 266.5 229H50.5C44.1487 229 39 223.851 39 217.5V90.5ZM54 94V214H263V94H54Z",
    fill: "#102F5D"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 64.5,
    y: 103.5,
    width: 187,
    height: 100,
    fill: "#102F5D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9767 243.5L15.5 286.5H301.5L270.023 243.5H46.9767Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.9249 239.07C42.3374 237.14 44.5854 236 46.9768 236H270.023C272.415 236 274.663 237.14 276.075 239.07L307.552 282.07C309.221 284.35 309.467 287.373 308.189 289.893C306.911 292.412 304.325 294 301.5 294H15.5C12.6749 294 10.0895 292.412 8.81141 289.893C7.53334 287.373 7.77948 284.35 9.4482 282.07L40.9249 239.07ZM50.7814 251L30.2849 279H286.715L266.219 251H50.7814Z",
    fill: "#102F5D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9767 221.5L15.5 264.5H301.5L270.023 221.5H46.9767Z",
    fill: "#102F5D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.9249 217.07C42.3374 215.14 44.5854 214 46.9768 214H270.023C272.415 214 274.663 215.14 276.075 217.07L307.552 260.07C309.221 262.35 309.467 265.373 308.189 267.893C306.911 270.412 304.325 272 301.5 272H15.5C12.6749 272 10.0895 270.412 8.81141 267.893C7.53334 265.373 7.77948 262.35 9.4482 260.07L40.9249 217.07ZM50.7814 229L30.2849 257H286.715L266.219 229H50.7814Z",
    fill: "#102F5D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M121.066 243.5L110.5 258.5H206.5L195.934 243.5H121.066Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 264.5H301.5V286.5H15.5V264.5Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 264.5L15.5 257H301.5L309 264.5V286.5L301.5 294H15.5L8 286.5V264.5ZM23 272V279H294V272H23Z",
    fill: "#102F5D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M176.759 190.926C176.759 207.812 190.492 221.5 207.433 221.5H306.5C289.559 221.5 275.826 207.812 275.826 190.926L276.241 95.0737C276.241 78.1883 262.508 64.5 245.567 64.5H146.5C163.441 64.5 177.174 78.1883 177.174 95.0737L176.759 190.926Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M306.5 230H207.433C185.824 230 168.259 212.532 168.259 190.926V190.908L168.674 95.0737C168.674 95.0679 168.674 95.062 168.674 95.0562C168.664 82.8993 158.766 73 146.5 73V56H245.567C267.176 56 284.741 73.4678 284.741 95.0737V95.0921L284.326 190.926C284.326 190.932 284.326 190.938 284.326 190.943C284.336 203.1 294.233 213 306.5 213V230ZM274.171 213C269.854 206.723 267.326 199.122 267.326 190.926V190.908L267.741 95.0737C267.741 95.0681 267.741 95.0625 267.741 95.0569C267.732 82.8997 257.834 73 245.567 73H178.829C183.146 79.2774 185.674 86.8778 185.674 95.0737V95.0921L185.259 190.926C185.259 190.932 185.259 190.938 185.259 190.944C185.269 203.101 195.166 213 207.433 213H274.171Z",
    fill: "#102F5D"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M341.5 190.5C341.5 207.621 327.74 221.5 310.765 221.5H211.5C228.474 221.5 242.235 207.621 242.235 190.5H341.5Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.5 230H310.765C332.503 230 350 212.246 350 190.5V182H233.735V190.5C233.735 202.995 223.711 213 211.5 213V230ZM243.75 213C246.617 208.84 248.71 204.102 249.823 199H331.361C328.038 207.239 320.032 213 310.765 213H243.75Z",
    fill: "#102F5D"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M195.5 104.5C195.5 101.186 198.186 98.5 201.5 98.5H251.5C254.814 98.5 257.5 101.186 257.5 104.5C257.5 107.814 254.814 110.5 251.5 110.5H201.5C198.186 110.5 195.5 107.814 195.5 104.5Z",
    fill: "#102F5D"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M195.5 125.5C195.5 122.186 198.186 119.5 201.5 119.5H251.5C254.814 119.5 257.5 122.186 257.5 125.5C257.5 128.814 254.814 131.5 251.5 131.5H201.5C198.186 131.5 195.5 128.814 195.5 125.5Z",
    fill: "#102F5D"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M195.5 146.5C195.5 143.186 198.186 140.5 201.5 140.5H251.5C254.814 140.5 257.5 143.186 257.5 146.5C257.5 149.814 254.814 152.5 251.5 152.5H201.5C198.186 152.5 195.5 149.814 195.5 146.5Z",
    fill: "#102F5D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutomaticInvoiceGeneration);
export default __webpack_public_path__ + "static/media/automatic-invoice-generation.aeb98f5d066e0154c0f6979db9fec9ba.svg";
export { ForwardRef as ReactComponent };